import React from 'react'

interface BookmarksOutlinedProps {
  size?: number
  color?: string
  className?: string
}

// Material "BookmarksOutlined" path, inlined so @mui/icons-material (which needs
// @mui/material and emotion at runtime) is not pulled in for one icon.
const BookmarksOutlined: React.FC<BookmarksOutlinedProps> = ({ size = 16, color = 'currentColor', className }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 24 24' fill={color} className={className} aria-hidden='true'>
    <path d='M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7zm4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2m-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2' />
  </svg>
)

export default BookmarksOutlined
